import { Injectable } from '@angular/core';

import { Incentive } from './incentive';
import { INCENTIVES } from './incentives';
import { MOCKINCENTIVES } from './mock-incentives';

@Injectable()
export class IncentivesService {

  getIncentives(): Promise<Incentive[]> {
    return Promise.resolve(INCENTIVES);
  }

  getMockIncentives(): Promise<Incentive[]> {
    return Promise.resolve(MOCKINCENTIVES);
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/kanban/components/strategy-overview/incentives/incentives.service.ts